const dateTime = new Intl.DateTimeFormat("fr-FR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});
const dateOnly = new Intl.DateTimeFormat("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
const timeOnly = new Intl.DateTimeFormat("fr-FR", { hour: "2-digit", minute: "2-digit" });

export const formatDateTime = (iso: string | null | undefined) => (iso ? dateTime.format(new Date(iso)) : "—");
export const formatDate = (iso: string | null | undefined) => (iso ? dateOnly.format(new Date(iso)) : "—");
export const formatTime = (iso: string | null | undefined) => (iso ? timeOnly.format(new Date(iso)) : "—");

/** "1985" | "1985-03" | "1985-03-14" → "1985" | "03/1985" | "14/03/1985" */
export function formatBirth(partial: string | null | undefined): string {
  if (!partial) return "—";
  return partial.split("-").reverse().join("/");
}

/**
 * User input "YYYY" or "DD/MM/YYYY" → API format "YYYY" or "YYYY-MM-DD".
 * Format conversion only: whether the date exists is checked by the API.
 * Returns null for an empty field and undefined for an unreadable one.
 */
export function birthInputToApi(raw: string): string | null | undefined {
  const value = raw.trim();
  if (!value) return null;
  if (/^\d{4}$/.test(value)) return value;
  const match = value.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/);
  if (!match) return undefined;
  const [, d, m, y] = match;
  return `${y}-${m!.padStart(2, "0")}-${d!.padStart(2, "0")}`;
}

export function initials(fullName: string): string {
  return (
    fullName
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]!.toUpperCase())
      .join("") || "?"
  );
}

export const percent = (score: number) => `${Math.round(score * 100)} %`;
